import { WelcomePage } from '../component';

export default WelcomePage;
